import React from 'react';
import PropTypes from 'prop-types';
import Panel from '../Panel';
import TabMenu from '../TabMenu';
import Hero from '../Hero';

export default function UserAdminHeader(props) {
  return (
    <>
      <Hero title={props.title} />

      <Panel fix>
        <TabMenu title="Account" to={`/user/account`} />
        <TabMenu title="Notifications" to={`/user/notifications`} />
      </Panel>
    </>
  );
}

UserAdminHeader.propTypes = {
  title: PropTypes.string,
};
